import { useNewsletterInteractor } from '../interactor/useNewsletterInteractor';
import { HeroView } from '../view/HeroView';

/**
 * Presenter (Controller) for Hero Section
 * Connects the Interactor (business logic) with the View (UI)
 */
export const HeroPresenter = () => {
  const { email, setEmail, isSubmitting, message, handleSubscribe } = useNewsletterInteractor();

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleSubscribe();
  };

  return (
    <HeroView
      email={email}
      onEmailChange={handleEmailChange}
      onSubmit={handleSubmit}
      isSubmitting={isSubmitting}
      message={message}
    />
  );
};

export default HeroPresenter;
